import { ofType } from 'redux-observable';
import { combineLatest, merge, of } from 'rxjs';
import { filter, mergeMap, take } from 'rxjs/operators';
import type { SpEpic } from 'shared/middlewares/epic/epicMiddleware.factory';
import { productDescriptionsRequested } from 'state/product-description/action';
import { productsReferentialRequested } from 'state/productsReferential/productsReferential.action';
import { workspaceTabsFetchRequested } from 'state/workspaces/workspace.actions';

export function navigateToStaticWorkspaceEpic(): SpEpic {
  return action$ => {
    const navigationToStaticQuoteForm$ = action$.pipe(
      ofType('ROUTE_CHANGED'),
      filter(({ path }) => path === '/static'),
    );
    const dashboardShown$ = action$.pipe(ofType('WORKSPACE_SHOW_DASHBOARD'));
    const userInfoReceived$ = action$.pipe(ofType('USER_CURRENT_RECEIVED'));

    const productReferentialLoaded$ = action$.pipe(
      ofType('PRODUCTS_REFERENTIAL_LOADED', 'PRODUCTS_REFERENTIAL_LOADING_FAILED'),
    );

    return combineLatest([
      merge(navigationToStaticQuoteForm$, dashboardShown$),
      userInfoReceived$,
      productReferentialLoaded$,
    ]).pipe(
      take(1),
      mergeMap(() => of(workspaceTabsFetchRequested('static'))),
    );
  };
}

export function loadProductDescriptionEpic(): SpEpic {
  return action$ =>
    action$.pipe(
      ofType('USER_CURRENT_RECEIVED'),
      take(1),
      mergeMap(() => of(productDescriptionsRequested(), productsReferentialRequested())),
    );
}
